import { render, staticRenderFns } from "./UserInfos.vue?vue&type=template&id=19f31c75&scoped=true"
import script from "./UserInfos.vue?vue&type=script&lang=js"
export * from "./UserInfos.vue?vue&type=script&lang=js"
import style0 from "./UserInfos.vue?vue&type=style&index=0&id=19f31c75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f31c75",
  null
  
)

export default component.exports